import EventList from '../components/EventList.vue'
import { parseEvent } from '../services/EventService'
import { makeEntityRoute } from '../services/EntityService'

export default {
    components: {
        EventList
    },
    data () {
        return {
            events: [],
            isLoadingEvents: true,
            isLoadingMoreEvents: false,
            page: 1,
            pagination: null
        }
    },
    methods: {
        fetchEvents () {
            throw new Error('fetchEventsSpecific must be overridden by component.')
        },
        loadEvents () {
            const now = new Date()
            const schemaOrgOrigin = window.location.origin

            this.isLoadingEvents = this.page === 1
            this.isLoadingMoreEvents = !this.isLoadingEvents

            this.fetchEvents()
                .then(({ events, pagination }) => {
                    const nextEvents = events.map(rawEvent => this.parseEvent(rawEvent, this.$config.isIntegrated, now, schemaOrgOrigin))
                    this.events = this.page === 1 ? nextEvents : this.events.concat(nextEvents)
                    this.pagination = pagination
                })
                .catch(err => this.catchAndNotify(err))
                .finally(() => {
                    this.isLoadingEvents = false
                    this.isLoadingMoreEvents = false
                })
        },
        loadMoreEvents () {
            if (this.pagination && this.page >= this.pagination.last_page) { return }
            this.page += 1
            this.loadEvents()
        },
        makeEventRoute (event) {
            return makeEntityRoute('events', event)
        },
        parseEvent
    }
}
